import { AppStore } from 'app/store'

export const selectIsDarkTheme = (state: AppStore) => state.app.isDarkTheme
export const selectAdmin = (state: AppStore) => state.app.admin
export const selectIsVerified = (state: AppStore) => state.app.isVerified
export const selectIsLoading = (state: AppStore) => state.app.isLoading
export const selectAppError = (state: AppStore) => state.app.error
